export const isSlateValue = (val: unknown): val is SlateValue => {
  return Boolean(val && Array.isArray(val));
};
